import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson = () => {
  let initData: any = {
    table: "shop_manager",
    list_id: "shop_manager_list",
    x_column_list_arr: [
      { "key": "a_user_name", "name": "이름", "width": "100", "is_show": "1" },
      { "key": "a_is_order_push", "name": "푸시여부", "width": "100", "is_show": "1" },
      { "key": "a_is_order_sms", "name": "문자여부", "width": "100", "is_show": "1" },
    ],
    list_opt_origin: {
      'now_page': 1,
      'num_per_page': 30,
      'order_id': '',
      'order_type': '',
      's_date_type': '',
      's_start_date': '',
      's_end_date': '',
      'sc': {},
    },
    order_id_col_arr: [
      { "value": "", "text": "없음" },
    ]
  };
  initData.pri_col_arr = ["a_main_user_seq"];
  const xColumnArr: any = XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;